import React from "react";
import { SCHOOL } from "@/lib/constants";
import { MessageCircle } from "lucide-react";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={SCHOOL.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Eknoor on WhatsApp"
      data-testid="floating-whatsapp-button"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-maple-navy text-maple-cream px-4 py-3 shadow-[0_14px_36px_rgba(31,45,36,0.32)] hover:bg-maple-navy2 transition-colors wa-pulse"
    >
      <MessageCircle className="h-5 w-5" aria-hidden="true" />
      <span className="hidden sm:inline text-sm font-medium">WhatsApp Us</span>
    </a>
  );
};
